'use strict';

var StrategiesToolbarController = function StrategiesToolbarController($scope, $rootScope, searchCriteriaConstantsService, userPreferencesService) {
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.$on('scenarios:load', function () {
    $scope.loadingScenariosInProgress = true;
  });
  $scope.$on('scenarios:loaded', function () {
    $scope.loadingScenariosInProgress = false;
  });
  $scope.setDefaultListing = function () {
    var defaultList = userPreferencesService.getUserSettingComponent('defaultRuleStrategyListing', 'rulesAndStrategies');
    return defaultList === 'myRulesStrategies';
  };
  $scope.screen = searchCriteriaConstantsService.STRATEGIES;
};
StrategiesToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'UserPreferencesService'];
module.exports = StrategiesToolbarController;